import { render, staticRenderFns } from "./deliveryoffer.vue?vue&type=template&id=8d4ecd48&"
import script from "./deliveryoffer.vue?vue&type=script&lang=js&"
export * from "./deliveryoffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports